import React from 'react';
import { translate } from 'react-i18next';
import FieldGroup from '../field_group/FieldGroup';
import Form from '../form/Form';
import { requiredValidator } from '../field_group/validators';
import { getErrorValue } from '../../utils/utility';

export class MaterialOpaqueDetail extends React.Component {
  constructor(props) {
    super(props);
    this.formRef = undefined;
  }

  getMaterialData() {
    return this.formRef.getFormData();
  }

  render() {
    const {
      name,
      density,
      thermal_conductivity,
      specific_heat,
      description,
      image,
    } = this.props.material;

    const { disabled, fieldErrors, t, ...otherAttr } = this.props;
    const customAttr = { disabled };
    return (
      <Form
        {...otherAttr}
        image={image}
        errorMessage={getErrorValue(fieldErrors, 'detail')}
        ref={ref => (this.formRef = ref)}
      >
        <FieldGroup
          id="material-opaque-name"
          field="name"
          type="text"
          label={t('name')}
          placeholder={t('opaque material name')}
          value={name}
          validators={[requiredValidator]}
          errorMessage={getErrorValue(fieldErrors, 'name')}
          {...customAttr}
        />
        <FieldGroup
          id="material-opaque-density"
          field="density"
          type="number"
          label={<span>{t('density')} ({t('kg/cubic_m')})</span>}
          placeholder="2400"
          value={density}
          validators={[requiredValidator]}
          errorMessage={getErrorValue(fieldErrors, 'density')}
          {...customAttr}
        />
        <FieldGroup
          id="material-opaque-thermal-conductivity"
          field="thermal_conductivity"
          type="number"
          label={`${t('thermal conductivity')} (${t('W/sq_m_C')})`}
          placeholder="0.93"
          value={thermal_conductivity}
          validators={[requiredValidator]}
          errorMessage={getErrorValue(fieldErrors, 'thermal_conductivity')}
          {...customAttr}
        />
        <FieldGroup
          id="material-opaque-specific-heat"
          field="specific_heat"
          type="number"
          label={<span>{t('specific heat')} ({t('kJ/kg℃')})</span>}
          placeholder="0.70"
          value={specific_heat}
          validators={[requiredValidator]}
          errorMessage={getErrorValue(fieldErrors, 'specific_heat')}
          {...customAttr}
        />
        <FieldGroup
          id="material-opaque-description"
          field="description"
          componentClass="textarea"
          label={t('description')}
          value={description}
          {...customAttr}
        />
      </Form>
    );
  }
}

MaterialOpaqueDetail.defaultProps = {
  material: {},
};

export default translate('translations', { withRef: true })(MaterialOpaqueDetail);



// WEBPACK FOOTER //
// ./src/components/material_opaque/MaterialOpaqueDetail.js